// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__25Kbl","overlay":"Modal_overlay__mzaiv","flex":"Modal_flex__F98Y5","invisible":"Modal_invisible__3fj4l"};